import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { HintPopoverComponent } from '../components/hint-popover/hint-popover.component';
import { NumberFormatPipe } from '../pipes/number-format.pipe';
import { NgxLoadingModule } from "ngx-loading";
import { MatTabsModule } from "@angular/material/tabs";
import { SearchSymbolsModalComponent } from '../components/search-symbols-modal/search-symbols-modal.component';
import { PurchasePowerDetailsComponent } from '../components/purchase-power-details/purchase-power-details.component';
import { MatIconModule } from '@angular/material/icon';
import { OrderBookComponent } from "../components/order-book/order-book.component";
import { UserTradesSummaryComponent } from '../components/user-trades-summary/user-trades-summary.component'; 
import { MatTooltipModule } from "@angular/material/tooltip";
import { DataTablesModule } from "angular-datatables";
import { MatDialogModule } from "@angular/material/dialog";
import { MatStepperModule } from '@angular/material/stepper';
import { RequestWithdrawModalComponent } from '../components/profile/request-withdraw-modal/request-withdraw-modal.component';
import { RequestDepositModalComponent } from '../components/profile/request-deposit-modal/request-deposit-modal.component';
import { MatRadioModule } from "@angular/material/radio";
import { RequestReserveSharesModalComponent } from '../components/profile/request-reserve-shares-modal/request-reserve-shares-modal.component';
import { RequestT0ModalComponent } from '../components/profile/request-t0-modal/request-t0-modal.component';
import { RequestComplaintModalComponent } from '../components/profile/request-complaint-modal/request-complaint-modal.component';
import { RequestSuggestionModalComponent } from '../components/profile/request-suggestion-modal/request-suggestion-modal.component';
import { RequestCouponsComponent } from '../components/profile/request-coupons/request-coupons.component';
import { SummaryModalComponent } from '../components/profile/summary-modal/summary-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RequestTransferComponent } from '../components/profile/request-transfer/request-transfer.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { UserProfileComponent } from '../screens/user-profile/user-profile.component';
import { UserPortfolioComponent } from '../components/user-portfolio/user-portfolio.component';
import { MatButtonModule } from '@angular/material/button';
import { AccountHeaderComponent } from '../components/account-header/account-header.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { NgCircleProgressModule } from "ng-circle-progress";
import { TwoDigitDecimalNumberDirective } from '../services/two-digit-decimal-number.directive';
import { InputCommaSepreatedDirective } from "../services/input-comma-sepreated.directive";
import { InputCommaSepreatedPipe } from "../services/input-comma-sepreated.pipe"
import { ProfileRoutingModule } from '../screens/profile/profile-routing.module';
import { SideNavComponent } from '../screens/profile/side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { RequestEmailChangeComponent } from '../components/profile/request-email-change/request-email-change.component';
import { RequestChangePhoneComponent } from '../components/profile/request-change-phone/request-change-phone.component';
import { RequestAddPhoneComponent } from '../components/profile/request-add-phone/request-add-phone.component';
import {MatListModule} from '@angular/material/list';
import { UserPortfolioSavingsComponent } from '../components/user-portfolio-savings/user-portfolio-savings.component';




// TODO:: When all modules converted to lazy load mode import this module in all modules
// TODO:: remove all packages import from app module  

@NgModule({
  declarations: [
    HintPopoverComponent,
    NumberFormatPipe,
    SearchSymbolsModalComponent,
    PurchasePowerDetailsComponent,
    OrderBookComponent,
    UserTradesSummaryComponent,
    RequestDepositModalComponent,
    RequestWithdrawModalComponent,
    RequestReserveSharesModalComponent,
    RequestT0ModalComponent,
    RequestComplaintModalComponent,
    RequestSuggestionModalComponent,
    SummaryModalComponent,
    RequestCouponsComponent,
    RequestEmailChangeComponent,
    RequestTransferComponent,
    UserProfileComponent,
    UserPortfolioComponent,
    AccountHeaderComponent,
    TwoDigitDecimalNumberDirective,
    InputCommaSepreatedDirective,
    InputCommaSepreatedPipe,
    SideNavComponent,
    RequestChangePhoneComponent, 
    RequestAddPhoneComponent,
    UserPortfolioSavingsComponent
  ],
  imports: [
    
    NgCircleProgressModule,
    MatProgressBarModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    MatDatepickerModule,
    MatIconModule,
    NgSelectModule,
    NgbPopoverModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    NgbModule,
    MatTooltipModule,
    DataTablesModule,
    MatDialogModule,
    MatStepperModule,
    MatRadioModule,
    FormsModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatButtonModule,
    MatButtonToggleModule,
    NgxLoadingModule,
    RouterModule ,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: "primary", // set defaults here
    }),
    MatListModule
  ],
  exports: [
    TranslateModule,
    FormsModule,
    MatDatepickerModule,
    NgSelectModule,
    ConfirmationPopoverModule,
    NgbPopoverModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    HintPopoverComponent,
    NumberFormatPipe,
    NgApexchartsModule,
    NgbModule,
    NgxLoadingModule,
    MatTabsModule,
    MatIconModule,
    MatButtonToggleModule,
    SearchSymbolsModalComponent,
    PurchasePowerDetailsComponent,
    OrderBookComponent,
    UserTradesSummaryComponent,
    RequestDepositModalComponent,
    RequestWithdrawModalComponent,
    RequestReserveSharesModalComponent,
    RequestT0ModalComponent,
    RequestComplaintModalComponent,
    RequestSuggestionModalComponent,
    SummaryModalComponent,
    RequestCouponsComponent,
    RequestEmailChangeComponent,
    RequestTransferComponent,
    MatCheckboxModule,
    MatButtonModule,
    InputCommaSepreatedDirective,
    InputCommaSepreatedPipe,
    SideNavComponent,
    RequestChangePhoneComponent, 
    RequestAddPhoneComponent
    
  ],
  providers: [
    InputCommaSepreatedPipe
  ]

})
export class SharedModule { }